import { Box, Typography } from '@mui/material';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { EmploymentData } from '~/data/employee';

import { Form, Restrict } from '../../useScheduleChanges';

import { FormComponent } from './components/FormComponent';
import { useEmployment } from './useEmployment';

export const Employment = ({
  scheduleFormMethods,
  employmentDataPending,
  restrictField,
  index,
}: {
  scheduleFormMethods: UseFormReturn<Form>;
  employmentDataPending?: EmploymentData;
  restrictField: Restrict;
  index: number;
}) => {
  const { t } = useTranslation();
  const {
    terminationReasons,
    employmentData,
    fixedTermReasons,
    trialPeriodOptions,
    employmentTypeOptions,
    loading,
    hasWorkEmail,
  } = useEmployment(employmentDataPending);

  return (
    <Box>
      <Typography sx={{ fontWeight: 'bold', fontSize: '16px' }}>
        {`${t('laEmployment')}`}
      </Typography>
      <FormComponent
        index={index}
        restrictField={restrictField}
        scheduleFormMethods={scheduleFormMethods}
        terminationReasons={terminationReasons}
        employmentData={employmentData}
        fixedTermReasons={fixedTermReasons}
        trialPeriodOptions={trialPeriodOptions}
        employmentTypeOptions={employmentTypeOptions}
        loading={loading}
        newEmpl={!employmentDataPending && index !== 0}
        hasWorkEmail={hasWorkEmail}
      />
    </Box>
  );
};
